<template>

	<v-content>
		<v-container fluid fill-height>
			<div style="width:100%">
				<v-tabs color="indigo " slider-color="white" dark grow fixed-tabs>

					<v-tab>GOOGLE</v-tab>
					<v-tab>Facebook</v-tab>
					<v-tab>Instagram</v-tab>
					<v-tab>MYSQL</v-tab>

					<v-tab-item >
						<PlatformAccountsListBody platform="google" />
					</v-tab-item>
					<v-tab-item >
						<PlatformAccountsListBody platform="facebook" />
					</v-tab-item>
					<v-tab-item >
						<PlatformAccountsListBody platform="instagram" />
					</v-tab-item>
					<v-tab-item >
						<PlatformAccountsListBody platform="mysql" />
					</v-tab-item>

				</v-tabs>
			</div>
		</v-container>
	</v-content>


</template>
 
<script>
	import PlatformAccountsListBody from "@/includes/Platform/Accounts/ListBody"
	export default {
		name: "AccountsIndex",
		components : {
			PlatformAccountsListBody
		},
		data: () => ({
			tabs: {
				tabTitles: [
					{title : "Çizelge"},
					{title : "Markalar"},
					{title : "Raporlar"}
				]
			}
		})
	}
</script>